import React from 'react';
import { Link } from 'react-router-dom';
import { CURRENT_YEAR } from '../utils/clinicInfo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* 치과 정보 */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/assets/한앤손부부치과_로고_small.webp" 
                alt="한앤손 부부치과 로고" 
                className="h-12 w-auto mr-3"
              />
              <h3 className="text-xl font-bold text-white">한앤손 부부치과</h3>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              정확한 진단과 섬세한 치료로 평생 주치의가 되겠습니다.<br />
              부부 원장이 직접 책임지는 맞춤형 치료를 제공합니다.
            </p>
            
            {/* 주소 및 연락처 */}
            <div className="space-y-3">
              <div className="flex items-start">
                <svg className="w-5 h-5 text-secondary mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <div>
                  <p className="text-gray-300">충청북도 진천군 덕산읍 공원로 4</p>
                  <p className="text-gray-400 text-sm">JH빌딩 3층</p>
                </div>
              </div>
              
              <div className="flex items-center">
                <svg className="w-5 h-5 text-secondary mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <a href="tel:043-534-3434" className="text-secondary hover:text-orange-300 font-semibold transition-colors">
                  043-534-3434
                </a>
              </div>
            </div>
          </div>

          {/* 진료시간 */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">진료시간</h4>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-300">평일</span>
                <span className="text-gray-300">09:00-18:00</span>
              </div>
              <div className="flex justify-between">
                <span className="text-secondary font-medium">화요일</span>
                <span className="text-secondary font-medium">09:00-20:00</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-300">토요일</span>
                <span className="text-gray-300">09:00-13:00</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-400">일요일·공휴일</span>
                <span className="text-red-400">휴진</span>
              </div>
              <div className="pt-2 border-t border-gray-700">
                <div className="flex justify-between">
                  <span className="text-gray-400">점심시간</span>
                  <span className="text-gray-400">12:30-14:00</span>
                </div>
              </div>
            </div>
          </div>

          {/* 빠른 링크 */}
          <div className="hidden md:block">
            <h4 className="text-lg font-semibold mb-4 text-white">빠른 링크</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/clinic-intro?tab=intro" className="text-gray-300 hover:text-secondary transition-colors">
                  치과소개
                </Link>
              </li>
              <li>
                <Link to="/natural-teeth?tab=resin" className="text-gray-300 hover:text-secondary transition-colors">
                  자연치아 살리기
                </Link>
              </li>
              <li>
                <Link to="/front-teeth?tab=resin-diastema" className="text-gray-300 hover:text-secondary transition-colors">
                  앞니 자신감
                </Link>
              </li>
              <li>
                <Link to="/implant?tab=custom" className="text-gray-300 hover:text-secondary transition-colors">
                  임플란트
                </Link>
              </li>
              <li>
                <Link to="/orthodontics?tab=non-extraction" className="text-gray-300 hover:text-secondary transition-colors">
                  교정치료
                </Link>
              </li>
              <li>
                <Link to="/children" className="text-gray-300 hover:text-secondary transition-colors">
                  어린이 치료
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* 하단 구분선 및 카피라이트 */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-400 mb-4 md:mb-0">
              <p>&copy; {CURRENT_YEAR} 한앤손 부부치과. All rights reserved.</p>
            </div>
            
            {/* 예약 버튼 */}
            <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
              <span className="text-sm text-gray-300">예약 문의</span>
              <a 
                href="tel:043-534-3434" 
                className="bg-primary hover:bg-secondary text-white px-6 py-2 rounded-full transition-colors font-medium text-sm"
              >
                전화 예약
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 